"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
exports.formatNumber = (value, locales, options) => new Intl.NumberFormat(locales, options).format(value);
//# sourceMappingURL=format-number.js.map